var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown",domProps:{"innerHTML":_vm._s(_vm.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }